import Home from "../views/Home.vue";
import MyCourses from "../views/MyCourses.vue";
import Profile from "../views/Profile.vue";
import Courses from "../views/Courses.vue";
import Course from "../views/Course.vue";
import Exams from "../views/Exams.vue";
import MyExams from "../views/MyExams/MyExams.vue";
import MyHomeworks from "../views/MyExams/MyHomeworks.vue";
import Teachers from "../views/Teachers.vue";
import Teacher from "../views/Teacher.vue";
import Exam from "../views/Exam.vue";
import Wallet from "../views/Wallet/index.vue";
import Welcome from "../views/Welcome.vue";
import Support from "../views/Support.vue";

const routes = [
    {
        path: '/',
        name: 'welcome',
        component: Welcome,
        meta :{
            requiresAuth: false,
            requiresGuest: true,
            footer: {
                show: true,
                notFixed: true,
            },
            whiteBackground: true,
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta :{
            title: 'الصفحة الرئيسية',
            requiresAuth: true
        }
    },
    {
        path: '/courses',
        name: 'courses',
        component: Courses,
        meta :{
            title: 'الدورات التعليمية',
            // requiresAuth: true
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta :{
            title: 'الملف الشخصي',
            requiresAuth: true
            // whiteBackground: true,
        }
    },
    {
        path: '/my-courses',
        name: 'my-courses',
        component: MyCourses,
        meta :{
            title: 'دوراتي',
            requiresAuth: true
            // whiteBackground: true,
        }
    },
    {
        path: '/courses/:id',
        name: 'course',
        component: Course,
        meta :{
            title: 'صفحة الدورة',
            // requiresAuth: true
            // temporaryMenu: true,
        }
    },
    {
        path: '/teachers',
        name: 'teachers',
        component: Teachers,
        meta :{
            title: 'المحاضرين',
            requiresAuth: true,
        }
    },
    {
        path: '/teachers/:id',
        name: 'teacher',
        component: Teacher,
        meta :{
            title: 'ملف المحاضر',
        }
    },
    {
        path: '/my-exams/exams',
        name: 'my-exams',
        component: MyExams,
        meta :{
            title: 'نتائج امتحاناتي',
            requiresAuth: true,
        }
    },
    {
        path: '/my-exams/homeworks',
        name: 'my-homeworks',
        component: MyHomeworks,
        meta :{
            title: 'نتائج واجباتي',
            requiresAuth: true,
        }
    },
    {
        path: '/exams',
        name: 'exams',
        component: Exams,
        props: true,
        meta :{
            title: 'الامتحان اﻹلكتروني',
            requiresAuth: true,
            temporaryMenu: true
        }
    },
    {
        path: '/exams/session',
        name: 'exam-session',
        component: Exam,
        props: true,
        meta :{
            title: 'الامتحان اﻹلكتروني',
            requiresAuth: true,
            temporaryMenu: true
        }
    },
    {
        path: '/wallet',
        name: 'wallet',
        component: Wallet,
        meta :{
            title: 'المحفظة الإلكترونية',
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import("../views/Login.vue"),
        meta :{
            title: 'تسجيل الدخول',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import("../views/Register.vue"),
        meta :{
            title: 'إنشاء حساب جديد',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import( '../views/ResetPassword.vue'),
        meta :{
        title: 'استعادة كلمة المرور',
        requiresAuth: false,
        requiresGuest: true,
        }
    },
    {
    path: '/confirm',
    name: 'confirm',
    component: () => import( '../views/Confirm.vue'),
    meta :{
        title: 'تأكيد البريد الإلكتروني',
        requiresAuth: true,
    }
    },
    {
        path: "/about",
        name: "about",
        component: () => import("../views/About.vue"),
        meta: {
            footer: {
                show: true,
            },
            title: 'عن المنصة'
        }
    },
    {
        path: "/(privacy-policy|privacy)",
        name: "privacy-policy",
        component: () => import("../views/Privacy.vue"),
        meta: {
            footer: {
                show: true,
            },
            title: 'سياسة الخصوصية',
        }
    },
    {
        path: "/help",
        name: "help",
        component: Support,
        meta: {
            title: 'المساعدة',
            footer: {
                show: true,
                notFixed: true,
            },
            whiteBackground: true,
        }
    },
    {
        path: '*',
        name: 'not-found',
        meta: {
            title: 'الصفحة غير موجودة',
            footer: {
                show: true,
            },
            backIcon: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue')
    }
  ];


  export default routes;